
// src/web/components/user-favorites-panel.jsx

import React from 'react'
import connect from '../../connects/user-favorites-panel'
import {
  Card,
  CardText,
  CardActions,
} from 'react-toolbox/lib/card'
import {
  Button,
} from 'react-toolbox/lib/button'
import theme from './themes/flat-card.css'
import successButtonTheme from './themes/success-button.css'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import FontIcon from 'react-toolbox/lib/font_icon'

class UserFavoritesPanel extends React.Component {
  render() {
    const {
      t,
      isFetching,
      favorites,
      current,
      groups,
      favoriteGroup,
      favoriteUser,
      setFavoriteUser,
      showUserSelectionDialog,
    } = this.props

    return (
    <Card theme={theme}>
      <CardText>
        <normal><strong>{t('label:グループ')}</strong></normal>
        <List selectable>
          {groups && groups.length > 0 && groups.map((group)=> 
            <ListItem key={group.group_id}
                disabled={isFetching}
                caption={group.name}
                avatar={group.icon_image.thumb_url}
                rightIcon={
                  <FontIcon value={group.favorite ? 'flag' : 'outlined_flag'}
                      style={{ color: group.favorite && '#FFCC00' || '#000', fontSize: '24px' }} />
                }
                onClick={()=> favoriteGroup(group, !group.favorite)} />
          )}
          {groups && groups.length == 0 &&
            <ListItem caption={t('label:お気に入り登録されたグループはありません')} />
          }
        </List>
      </CardText>

      <CardText>
        <normal><strong>{t('label:ユーザ')}</strong></normal>
        <CardActions>
          <Button theme={successButtonTheme}
              raised
              floating
              mini
              label={t('label:ユーザ追加')}
              icon='add'
              style={{ verticalAlign: 'bottom', mergin: '2px 5px' }}
              onClick={()=> showUserSelectionDialog(
                t('label:ユーザを選択'), true, 'ACCOUNT_MEMBERS', undefined, undefined,
                (users)=> setFavoriteUser(users, this.props)
              )} />
        </CardActions>
        <List selectable>
          {favorites && favorites.length > 0 && favorites.map((user)=> 
            <ListItem key={user.user_id}
                disabled={isFetching}
                caption={user.name}
                avatar={user.icon_image.thumb_url}
                rightIcon={
                  <FontIcon value={'flag'} style={{ color: '#FFCC00', fontSize: '24px' }} />
                }
                onClick={()=> favoriteUser(user, false)} />
          )}
          {favorites && favorites.length == 0 &&
            <ListItem caption={t('label:お気に入り登録されたユーザはありません')} />
          }
        </List>
      </CardText>
    </Card>
    )
  }
}

export const RawUserFavoritesPanel = UserFavoritesPanel
export default connect(UserFavoritesPanel)



// WEBPACK FOOTER //
// ./src/web/components/user-favorites-panel.jsx